module.exports = __webpack_public_path__ + "static/media/a7.b23cd27.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wangxingxing/a7.mp3
// module id = EtVY
// module chunks = 0